import { create } from 'zustand';

export interface CadenceModalState {
  open: boolean;
  missingDays: string[];
  originalRoute: string | null;
}

export interface CadenceStore extends CadenceModalState {
  openModal: (params: { missingDays: string[]; originalRoute: string }) => void;
  closeModal: () => void;
  reset: () => void;
}

const channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('cadence') : null;

export const useCadenceStore = create<CadenceStore>((set, get) => {
  const closeModal = () => {
    set({ open: false });
    channel?.postMessage('cleared');
  };

  if (channel) {
    channel.addEventListener('message', (e: MessageEvent) => {
      if (e.data === 'cleared' && get().open) {
        set({ open: false });
      }
    });
  }

  return {
    open: false,
    missingDays: [],
    originalRoute: null,
    openModal: ({ missingDays, originalRoute }) => {
      set({ open: true, missingDays, originalRoute });
    },
    closeModal,
    reset: () => {
      set({ open: false, missingDays: [], originalRoute: null });
    },
  };
});
